module.exports = __webpack_public_path__ + "img/code.af9c2c59.png";